__webpack_require__.j = "front-page";